import { apiService } from '@/api/apiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { RevealedInstructionsType } from '@/types/myVaultTypes';

export const revealSecureLinkApi = (token: string): Promise<ApiResponseType<RevealedInstructionsType>> => {
  return apiService.POST(`/secure-links/${token}/reveal/`, {});
};
